import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative flex flex-col items-center justify-center pt-12 pb-10 px-6 overflow-hidden bg-[#FFFBF5]" data-id="element-1">
      {/* Background organic blob */}
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-[#F5E6D0] rounded-full mix-blend-multiply filter blur-3xl opacity-50 -translate-y-1/2 translate-x-1/3 animate-blob" data-id="element-2" />
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-[#E8DCC8] rounded-full mix-blend-multiply filter blur-3xl opacity-50 translate-y-1/3 -translate-x-1/3 animate-blob animation-delay-2000" data-id="element-3" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-4">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-6" data-id="element-5">
          <span className="inline-block py-1 px-3 rounded-full bg-[#F5E6D0] text-[#C4704B] text-sm font-medium tracking-wide mb-4" data-id="element-6">
            PARA PADRES REALES (LOS QUE NO LLEGAN)
          </span>
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-[#2D3A4A] leading-[1.1] mb-5" data-id="element-7">
            A las 18:30 no te faltan ideas. <br data-id="element-8" />
            <span className="text-[#C4704B] italic" data-id="element-9">Te falta cuerpo.</span>
          </h1>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="max-w-2xl mx-auto text-lg md:text-xl text-[#2D3A4A]/80 leading-relaxed mb-8" data-id="element-10">
          <p className="mb-4" data-id="element-11">
            Estás cansada. Tu casa está a medias. Tu hijo pide atención justo
            cuando tu cabeza solo quiere silencio. Y entonces pasa lo de
            siempre: pantallas.
          </p>
          <p className="font-medium text-[#2D3A4A]" data-id="element-12">
            No porque seas "floja". Porque decidir una actividad, armarla, y
            encima lograr que "salga bien" es demasiado cuando estás en modo
            supervivencia.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative mb-8 group" data-id="element-13">
          <div className="absolute inset-0 bg-[#C4704B] rounded-3xl blur-xl opacity-20 group-hover:opacity-30 transition-opacity duration-500" data-id="element-14" />
          <img src="https://cdn.magicpatterns.com/uploads/rbePA2JqGQ1CPhWm6bi1c4/heylloyd-image-1771022010763.png" alt="Agenda Anti-Pantallas en iPad y iPhone" className="relative rounded-3xl shadow-2xl w-full max-w-3xl mx-auto border-4 border-white transform transition-transform duration-700 hover:scale-[1.01]" data-id="element-15" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6
      }} data-id="element-16">
          <p className="text-xl md:text-2xl font-serif italic text-[#2D3A4A] mb-5" data-id="element-17">
            La Agenda Anti-Pantallas existe para ese momento exacto: <br data-id="element-18" />
            cuando querés hacer algo mejor, pero no te da la vida para inventar.
          </p>

          <a href="#price-card" className="group relative inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all duration-200 bg-[#C4704B] rounded-full hover:bg-[#A65D3D] hover:shadow-lg hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#C4704B] no-underline" data-id="element-19">
            Quiero la Agenda Anti-Pantallas
            <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-20" />
          </a>
          <p className="mt-3 text-sm text-[#2D3A4A]/60" data-id="element-21">
            Descarga inmediata • Empezás hoy
          </p>
        </motion.div>
      </div>
    </section>;
}